/* CarritoWeb 2.0. No external libraries. Delegation survives Theme Editor section reloads. */
(() => {
  if (window.CarritoWebTheme) return;
  let aceleracionConVideos = false;
  let config = {};
  let plans = {};
  let videos = {};
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const touchTimers = new WeakMap();
  const animated = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({isIntersecting, target}) => {
      if (!isIntersecting) return;
      if (!motion.matches) target.classList.add('digital-enter');
      observer.unobserve(target);
    });
  }, {threshold: 0.08}) : null;

  function readConfiguration() {
    try { config = JSON.parse(document.getElementById('cw-theme-config')?.textContent || '{}'); }
    catch { config = {}; }
    plans = structuredClone(config.plans || {});
    videos = {...config.videos};
    const sources = [...document.querySelectorAll('[data-cw-plan]')].sort((a,b) => Number(a.dataset.cwPriority) - Number(b.dataset.cwPriority));
    sources.forEach(source => {
      const key = source.dataset.cwPlan;
      if (!plans[key]) return;
      const mappings = {cwProduct:'url',cwPlanMessage:'message',cwPlanPrice:'price',cwPlanDeposit:'deposit'};
      for (const [attribute, property] of Object.entries(mappings)) {
        if (source.dataset[attribute]) plans[key][property] = source.dataset[attribute];
      }
      if (key === 'acceleration') {
        for (const [attribute, property] of Object.entries({cwVideoProduct:'url',cwVideoMessage:'message',cwVideoPrice:'price',cwVideoDeposit:'deposit'})) {
          if (source.dataset[attribute]) videos[property] = source.dataset[attribute];
        }
      }
    });
    // Card product pickers are authoritative, including an empty selection.
    // Keep detail buttons synchronized without inheriting a different product.
    document.querySelectorAll('[data-cw-card-products]').forEach(source => {
      const key = source.dataset.cwPlan;
      if (plans[key]) plans[key].url = source.dataset.cwProduct || '';
      if (key === 'acceleration') videos.url = source.dataset.cwVideoProduct || '';
    });
  }
  const currentPlan = key => key === 'acceleration' && aceleracionConVideos ? videos : plans[key];
  const phone = () => String(config.phone || '').replace(/\D/g, '');
  const validPhone = () => /^\d{7,15}$/.test(phone());

  function renderState() {
    document.querySelectorAll('[data-cw-videos]').forEach(input => {
      input.checked = aceleracionConVideos;
      input.closest('.video-selector')?.classList.toggle('selected', aceleracionConVideos);
    });
    document.querySelectorAll('[data-cw-video-label]').forEach(el => { el.textContent = aceleracionConVideos ? config.labels?.videoSelected : config.labels?.videoLabel; });
    document.querySelectorAll('[data-cw-video-extra]').forEach(el => { el.textContent = `${config.labels?.optional || ''} · +${config.labels?.videoExtra || ''}`; });
    document.querySelectorAll('[data-cw-price]').forEach(el => { const p = currentPlan(el.dataset.cwPrice); if (p) el.textContent = p.price || ''; });
    document.querySelectorAll('[data-cw-name]').forEach(el => { const p = currentPlan(el.dataset.cwName); if (p) el.textContent = p.name || ''; });
    document.querySelectorAll('[data-cw-deposit]').forEach(el => {
      const p = currentPlan(el.dataset.cwDeposit);
      if (p) el.textContent = `${config.labels?.before || ''} ${p.deposit || ''} ${config.labels?.after || ''}`.trim();
    });
    document.querySelectorAll('[data-cw-payment]').forEach(link => {
      const key = link.dataset.cwPayment;
      // Normal card links are complete in Liquid and must never be disabled
      // by a missing or stale global configuration in the Theme Editor.
      if (link.hasAttribute('data-cw-card-payment') && key !== 'acceleration') return;
      const cardLink = [...document.querySelectorAll('[data-cw-card-payment]')]
        .find(candidate => candidate.dataset.cwPayment === key);
      const url = cardLink
        ? (key === 'acceleration' && aceleracionConVideos ? cardLink.dataset.videoUrl : cardLink.dataset.baseUrl)
        : currentPlan(key)?.url;
      const available = !!url;
      link.classList.toggle('is-unavailable', !available);
      if (available) {
        link.setAttribute('href', url);
        link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); link.removeAttribute('role');
      } else {
        link.removeAttribute('href'); link.setAttribute('aria-disabled','true'); link.setAttribute('tabindex','-1'); link.setAttribute('role','link');
      }
    });
    document.querySelectorAll('[data-cw-wa]').forEach(link => {
      const message = currentPlan(link.dataset.cwWa)?.message || link.dataset.cwMessage || config.message || '';
      link.dataset.cwCurrentMessage = message;
      link.href = `https://wa.me/${phone()}?text=${encodeURIComponent(message)}`;
    });
  }

  function resolveAnchors() {
    const targets = new Map();
    document.querySelectorAll('[data-cw-anchor]').forEach(el => { if (!targets.has(el.dataset.cwAnchor)) targets.set(el.dataset.cwAnchor, el); });
    document.querySelectorAll('[data-cw-target], [data-cw-nav-url], nav a').forEach(link => {
      const raw = link.dataset.cwTarget || link.dataset.cwNavUrl || link.getAttribute('href') || '';
      let key = raw;
      if (!link.dataset.cwTarget && !raw.startsWith('#')) return;
      key = key.replace(/^#/, '');
      const target = targets.get(key);
      if (target) { link.href = `#${target.id}`; link.dataset.cwTarget = key; }
      else if (raw.startsWith('#')) link.href = (config.root || '/') + raw;
      else if (link.dataset.cwNavUrl) link.href = raw;
    });
    const hash = decodeURIComponent(location.hash.slice(1));
    if (hash && targets.has(hash)) targets.get(hash).scrollIntoView({behavior: motion.matches ? 'instant' : 'smooth'});
  }

  function closeMenu(header) {
    const button = header?.querySelector('.menu-toggle');
    const nav = header?.querySelector('nav');
    nav?.classList.remove('open'); button?.setAttribute('aria-expanded','false');
  }
  function openFaq(button, open) {
    const item = button.closest('.cw-faq-item');
    const panel = item?.querySelector('.cw-faq-answer');
    if (!panel) return;
    button.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
  }
  function showNotice(message) {
    const dialog = document.getElementById('cw-notice');
    if (!dialog) return;
    dialog.querySelector('[data-cw-notice-text]').textContent = message;
    if (!dialog.open) dialog.showModal();
  }

  function initCarritoWebSection(root = document) {
    readConfiguration(); renderState(); resolveAnchors();
    root.querySelectorAll('.plan, .detail, .step-content, .feedback').forEach(el => {
      if (!observer || motion.matches || animated.has(el)) return;
      animated.add(el); observer.observe(el);
    });
  }
  document.addEventListener('click', event => {
    const target = event.target;
    const unavailable = target.closest('[data-cw-payment][aria-disabled="true"]');
    if (unavailable) { event.preventDefault(); return; }
    const wa = target.closest('[data-cw-wa]');
    if (wa && !validPhone()) { event.preventDefault(); showNotice(`${config.labels?.contactPending || ''}\n\n${wa.dataset.cwCurrentMessage || ''}`); return; }
    const menu = target.closest('.menu-toggle');
    if (menu) {
      const nav = menu.closest('[data-cw-component="cw-header"]')?.querySelector('nav');
      if (nav) menu.setAttribute('aria-expanded', String(nav.classList.toggle('open')));
      return;
    }
    if (target.closest('nav a')) closeMenu(target.closest('[data-cw-component="cw-header"]'));
    const question = target.closest('.cw-faq-question');
    if (question) {
      const open = question.getAttribute('aria-expanded') !== 'true';
      question.closest('.faq-list').querySelectorAll('.cw-faq-question').forEach(b => openFaq(b, b === question && open));
      return;
    }
    if (target.closest('[data-cw-close]')) document.getElementById('cw-notice')?.close();
    const dialog = document.getElementById('cw-notice');
    if (target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cw-videos]')) { aceleracionConVideos = event.target.checked; renderState(); }
    if (event.target.matches('[data-cw-variant]')) {
      const option = event.target.selectedOptions[0];
      const section = event.target.closest('[data-cw-product-section]');
      section.querySelector('[data-cw-product-price]').textContent = option.dataset.price;
      const submit = section.querySelector('[name="add"]'); submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? submit.dataset.soldOut : submit.dataset.available;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-cw-component="cw-header"]').forEach(header => {
      if (header.querySelector('nav.open')) { closeMenu(header); header.querySelector('.menu-toggle')?.focus(); }
    });
  });
  document.addEventListener('pointerdown', event => {
    if (!['touch','pen'].includes(event.pointerType)) return;
    const panel = event.target.closest('.plan, .detail');
    if (!panel) return;
    clearTimeout(touchTimers.get(panel)); panel.classList.add('is-touch-lit');
    touchTimers.set(panel, setTimeout(() => panel.classList.remove('is-touch-lit'),450));
  }, {passive:true});
  document.addEventListener('pointercancel', event => {
    const panel = event.target.closest('.plan, .detail');
    if (panel) { clearTimeout(touchTimers.get(panel)); panel.classList.remove('is-touch-lit'); }
  }, {passive:true});
  window.matchMedia('(min-width:769px)').addEventListener('change', e => { if(e.matches) document.querySelectorAll('[data-cw-component="cw-header"]').forEach(closeMenu); });
  motion.addEventListener('change', e => { if(e.matches) observer?.disconnect(); });
  document.addEventListener('shopify:section:load', e => initCarritoWebSection(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.plan,.detail,.step-content,.feedback').forEach(el => { observer?.unobserve(el); clearTimeout(touchTimers.get(el)); });
    setTimeout(() => initCarritoWebSection(document),0);
  });
  document.addEventListener('shopify:section:reorder', () => initCarritoWebSection(document));
  document.addEventListener('shopify:block:select', e => {
    const button = e.target.querySelector('.cw-faq-question'); if(button) openFaq(button,true);
    if(e.target.matches('.project')) e.target.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  });
  window.addEventListener('pageshow', () => initCarritoWebSection(document));
  window.CarritoWebTheme = {initCarritoWebSection};
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCarritoWebSection(document),{once:true});
  else initCarritoWebSection(document);
})();
